import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import RenewAndChangePlanAccepted from './routes/RenewAndChangePlanAccepted'

const RenewAndChangeSubscription = () => (
  <Switch>
    <Route key='renewAndChangePlanAccepted' path={ROUTES.profile.renewAndChangePlan.accepted} component={RenewAndChangePlanAccepted} exact />
  </Switch>
)

export default RenewAndChangeSubscription
